import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import {
    META_LINKS,
    META_NAMES,
    META_PROPERTIES,
} from "../../actions/App/utils";

export function createMetaTags(meta = {}) {
    const metaTags = [];
    Object.entries(meta).forEach(([key, value]) => {
        if (value) {
            if (META_PROPERTIES[key]) {
                metaTags.push({ property: key, content: value });
            } else if (META_NAMES[key]) {
                metaTags.push({ name: key, content: value });
            }
        }
    });
    return metaTags;
}

export function createLinkTags(meta) {
    const linkTags = [];
    Object.entries(meta).forEach(([key, value]) => {
        if (value && META_LINKS[key]) {
            linkTags.push({ rel: key, href: value });
        }
    });
    return linkTags;
}

export function createScriptTags(meta) {
    const scriptTags = [];
    Object.entries(meta).forEach(([key, value]) => {
        if (value && key === "jsonld") {
            scriptTags.push({
                type: "application/ld+json",
                innerHTML: `${JSON.stringify(value)}`,
            });
        }
    });
    return scriptTags;
}

/**
 * The DynamicHead component.
 *
 * Component to implement the dynamic document head
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the DynamicHead component
 */
export function DynamicHead() {
    const meta = useSelector((state) => state.app.meta);
    const title = useSelector((state) => state.app.title);
    const metaTags = createMetaTags(meta);
    const linkTags = createLinkTags(meta);
    const scriptTags = createScriptTags(meta);

    return (
        <Helmet
            title={title}
            meta={metaTags}
            link={linkTags}
            script={scriptTags}
        />
    );
}

export default DynamicHead;
